import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

import { Button } from "@themesberg/react-bootstrap";

import { Edit } from "@mui/icons-material";

import { useMediaQuery, useTheme } from "@mui/material";
import useCheckPermission from "../../../../utils/checkPermission";

const ActionMenu = (props) => {
  const { handleCreateEdit, handleDelete, data } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isXsScreen = useMediaQuery("(max-width:600px)");
  const isMobile = useMediaQuery("(max-width:768px)");
  const { isHidden } = useCheckPermission()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  console.log({ data }, "datadata")

  // If this is a voucher code and it has been redeemed, hide the Edit option
  const isVoucherAndRedeemed =
    data?.promocodesId && typeof data?.isRedeemed !== "undefined"
      ? !!data.isRedeemed
      : false;
  return (
    <div className="action-menu-container" style={{ lineHeight: 0 }}>
      <Button
        variant="btn text-btn"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="p-0 m-0"
        style={{
          minWidth: "auto",
          background: "transparent",
          boxShadow: "none",
          lineHeight: 0,
          height: isXsScreen ? "24px" : "auto",
        }}
      >
        <MoreVertRoundedIcon
          fontSize={isXsScreen ? "small" : "medium"}
          style={{ fontSize: isXsScreen ? "18px" : "24px" }}
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          dense: true,
          style: {
            padding: 0,
            margin: 0,
            display: "flex",
            flexDirection: "column",
          },
        }}
        slotProps={{
          paper: {
            style: {
              border: "none",

              padding: 0,
              margin: 0,
              minWidth: isXsScreen ? "80px" : isMobile ? "90px" : "100px",
              maxWidth: "100%",
              overflow: "hidden",
            },
          },
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        sx={{
          "& .MuiList-root": {
            padding: 0,
          },
          "& .MuiMenuItem-root": {
            padding: 0,
            minHeight: isXsScreen ? "24px" : "auto",
          },
          "& .MuiPaper-root": {
            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
          },
        }}
      >
        <MenuItem
          onClick={handleClose}
          style={{ padding: 0, margin: 0, height: "auto" }}
          hidden={
            isVoucherAndRedeemed ||
            isHidden({
              module: {
                key: data?.promocodesId ? "PromoCode" : "TransactionsBanking",
                value: "U",
              },
            })
          }
        >
          <Button
            variant="primary"
            size="sm"
            className="d-flex align-items-center justify-content-center w-100"
            onClick={() => handleCreateEdit("Edit", data)}
            style={{
              padding: isXsScreen
                ? "0.1rem 0.2rem"
                : isMobile
                  ? "0.3rem 0.3rem"
                  : "0.5rem 0.5rem",
              margin: 0,
              borderRadius: 0,
              fontSize: isXsScreen ? "0.65rem" : isMobile ? "0.7rem" : "0.8rem",
              lineHeight: isXsScreen ? "1" : "normal",
              height: isXsScreen ? "24px" : "auto",
            }}
          >
            {isXsScreen ? null : (
              <Edit
                fontSize="small"
                style={{
                  marginRight: "4px",
                  fontSize: isXsScreen ? "14px" : "16px",
                }}
              />
            )}
            <span>Edit</span>
          </Button>
        </MenuItem>

        <MenuItem
          onClick={handleClose}
          style={{ padding: 0, margin: 0, height: "auto" }}
          hidden={isHidden({ module: { key: data?.promocodesId ? "PromoCode" : "TransactionsBanking", value: "D" } })}
        >
          <Button
            variant="danger"
            size="sm"
            className="d-flex align-items-center justify-content-center w-100"
            onClick={() => data?.promocodesId ? handleDelete(data) : handleDelete(data?.bankDetailsId)}
            style={{
              padding: isXsScreen
                ? "0.1rem 0.2rem"
                : isMobile
                  ? "0.3rem 0.3rem"
                  : "0.5rem 0.5rem",
              margin: 0,
              borderRadius: 0,
              fontSize: isXsScreen ? "0.65rem" : isMobile ? "0.7rem" : "0.8rem",
              lineHeight: isXsScreen ? "1" : "normal",
              height: isXsScreen ? "24px" : "auto",
            }}
          >
            {isXsScreen ? null : (
              <DeleteForeverOutlinedIcon
                fontSize="small"
                style={{
                  marginRight: "4px",
                  fontSize: isXsScreen ? "14px" : "16px",
                }}
              />
            )}
            <span>Delete</span>
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ActionMenu;
